export const UPDATE_DISCOVERIES = 'UPDATE_DISCOVERIES'
export const UPDATE_DISCOVERY_PAGINATION = 'UPDATE_DISCOVERY_PAGINATION'
export const UPDATE_DISCOVERY_SEARCH_TERM = 'UPDATE_DISCOVERY_SEARCH_TERM'
